export const CREATE_CARE_PROVIDER_SUCCESS = 'CREATE_CARE_PROVIDER_SUCCESS';

export const createCareProviderSuccess = ({ careProvider }) => ({
    type: CREATE_CARE_PROVIDER_SUCCESS,
    payload: {
        careProvider,
    }
});
